export default __webpack_public_path__ + "c0afc0a05ec517eaee36a029a97c7609.ttf";